import React from "react";
import { ErrorSvg } from "assets/icons";
import { PasswordField } from "components/formfields";

const SettingProfileForm = () => {
  return (
    <div className="flex flex-col gap-4">
      <div>
        <PasswordField
          name={"currentPassword"}
          label={"Current Password"}
          placeholder="Enter Current Password"
          isRequired
        />
        <div className=" flex items-center gap-1 -translate-x-1 my-1">
          <ErrorSvg height={14} width={14} color={"#1467B0"} />
          <p className="text-xs tracking-tight text-secondary">
            <span className="font-bold">MUST</span> be 8-12 characters. Must
            contain atleast One Uppercase and One symbol.
          </p>
        </div>
      </div>
      <PasswordField
        name={"newPassword"}
        label={"New Password"}
        placeholder="Enter New Password"
        isRequired
      />
      <PasswordField
        name={"confirmPassword"}
        label={"Confirm New Password"}
        placeholder="Enter Confirm Password"
        isRequired
      />
    </div>
  );
};

export default SettingProfileForm;
